import { Box, Stack, Typography } from "@mui/material";

import StockPageHeader from "../../../components/StockPageHeader";
import StockCountStatusPill from "./StockCountStatusPill";
import { formatStockCountDate } from "../utils/stockCountFormatters";

export default function StockCountDetailHeader({
  stockCount,
  statusDescription = "",
  onBack,
}) {
  return (
    <Stack spacing={0} sx={{ alignItems: "center" }}>
      <Box sx={{ width: "100%" }}>
        <StockPageHeader title="Lista de Conteo" onBack={onBack} />
      </Box>
      {stockCount ? (
        <Box
          sx={{
            minWidth: { xs: 230, sm: 360 },
            maxWidth: { xs: "92vw", sm: 680 },
            px: 2,
            py: 0.65,
            bgcolor: "neutral.100",
            borderRadius: "0 0 9px 9px",
          }}
        >
          <Stack
            direction="row"
            spacing={0.75}
            useFlexGap
            sx={{
              alignItems: "center",
              justifyContent: "center",
              flexWrap: "wrap",
              rowGap: 0.5,
            }}
          >
            <Typography sx={{ color: "primary.900", fontSize: 11, fontWeight: 650 }}>
              Fecha límite: {formatStockCountDate(stockCount.deadlineAt)}
            </Typography>
            <Typography sx={{ color: "neutral.600", fontSize: 10 }}>·</Typography>
            <Typography
              noWrap
              title={stockCount.counterNameSnapshot}
              sx={{ color: "primary.900", fontSize: 11, fontWeight: 650 }}
            >
              Contador: {stockCount.counterNameSnapshot || "—"}
            </Typography>
            <Typography sx={{ color: "neutral.600", fontSize: 10 }}>·</Typography>
            <Typography
              noWrap
              title={stockCount.auditorNameSnapshot}
              sx={{ color: "primary.900", fontSize: 11, fontWeight: 650 }}
            >
              Auditor: {stockCount.auditorNameSnapshot || "—"}
            </Typography>
            <StockCountStatusPill
              status={stockCount.status}
              description={statusDescription}
            />
          </Stack>
        </Box>
      ) : null}
    </Stack>
  );
}
